<template>
  <div class="footer__bottom align-center">
    <p>{{ bottomFooterTagline }}</p>
  </div>
</template>

<script>
import FetchService from "../../../services/FetchService";
const fetchService = new FetchService();

export default {
  name: "BottomFooter",
  data() {
    return {
      bottomFooterTagline: ""
    };
  },
  methods: {
    getAll() {
      fetchService
        .getTextBlock(
          this.$parent.$parent.$parent.apiURL,
          "bottom-footer-tagline"
        )
        .then(response => {
          this.bottomFooterTagline = response.body.content;
        });
    }
  },
  created() {
    this.getAll();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/FooterComponents/BottomFooter.vue